module.exports = __webpack_public_path__ + "img/menu.8e519a29.svg";